export function waitForNextPaint() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
}

/** US Letter printable height with 12mm @page margins (96 CSS px per inch). */
const LETTER_HEIGHT_IN = 11;
const PAGE_MARGIN_MM = 12;
const CSS_PX_PER_IN = 96;
const MM_PER_IN = 25.4;

function getPrintablePageHeightPx() {
  const marginIn = (PAGE_MARGIN_MM * 2) / MM_PER_IN;
  return Math.floor((LETTER_HEIGHT_IN - marginIn) * CSS_PX_PER_IN);
}

/**
 * Chrome/Safari often ignore break-inside:avoid on flex/column layouts.
 * Measure cards after print styles apply and force page-break-before when needed.
 */
export function applyPrepSheetPrintPageBreaks(rootEl) {
  if (!rootEl) {
    return;
  }

  // Force layout after print-prep class toggles expanded card bodies.
  void document.body.offsetHeight;
  void rootEl.offsetHeight;

  const cards = rootEl.querySelectorAll('.prep-sheet-order-card');
  const printableHeight = getPrintablePageHeightPx();
  const cardGap = 16;

  cards.forEach((card) => {
    card.classList.remove('prep-sheet-page-break-before');
  });

  const banner = rootEl.querySelector('.prep-sheet-print-banner');
  let usedOnPage = banner?.offsetHeight ?? 0;

  cards.forEach((card) => {
    const cardHeight = card.getBoundingClientRect().height;

    if (usedOnPage > 0 && usedOnPage + cardHeight > printableHeight) {
      card.classList.add('prep-sheet-page-break-before');
      usedOnPage = 0;
    }

    usedOnPage += cardHeight + cardGap;

    if (usedOnPage > printableHeight) {
      usedOnPage = cardHeight + cardGap;
    }
  });
}

export function clearPrepSheetPrintPageBreaks(rootEl) {
  if (!rootEl) {
    return;
  }
  rootEl.querySelectorAll('.prep-sheet-page-break-before').forEach((card) => {
    card.classList.remove('prep-sheet-page-break-before');
  });
}
